import { useTranslation } from 'react-i18next';

import { Separator, Tag } from '~/components';
import { TruncateWithTooltip } from '~/modules/settings/components/TruncateWithTooltip';
import { MAX_TAG_CHARACTERS } from '~/modules/settings/constants';
import type { LabelGroup } from '~settings/api/lib/schemas';
import { HeaderSmall } from '~settings/components/HeaderSmall';

interface LabelGroupsProps {
  labelGroups: LabelGroup[];
}

export function LabelGroups({ labelGroups }: LabelGroupsProps) {
  const { t } = useTranslation('settings');

  if (!labelGroups?.length) {
    return null;
  }

  return (
    <div>
      <Separator className="my-lg" />
      <HeaderSmall>{t('labelGroup.list')}</HeaderSmall>
      <ul className="flex w-full flex-wrap gap-x-xs gap-y-sm">
        {labelGroups.map(({ id, name }) => (
          <Tag key={id} variant="secondary" className="max-w-full" asChild>
            <li>
              <TruncateWithTooltip maxCharacters={MAX_TAG_CHARACTERS}>
                {name}
              </TruncateWithTooltip>
            </li>
          </Tag>
        ))}
      </ul>
    </div>
  );
}
LabelGroups.displayName = 'LabelGroups';
